export const FormatDate = (param: string) => {
  if (!param) return param;

  const date = new Date(param);
  const offsetInMinutes = date.getTimezoneOffset();
  // Adjust for timezone offset (convert to milliseconds)
  date.setMinutes(date.getMinutes() - offsetInMinutes);

  return date
    .toLocaleString("en-US", {
      hour12: true,
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    })
    .replace(/\//g, "-")
    .replace(",", "");
};

export const FormatDateWithoutTime = (param: string) => {
  if (!param) return param;
  const date = new Date(param);
  const offsetInMinutes = date.getTimezoneOffset();
  date.setMinutes(date.getMinutes() - offsetInMinutes);
  return date
    .toLocaleString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
    .replace(/\//g, "-")
    .replace(",", "");
};

export const FormatDateVersionHistory = (param: string) => {
  if (!param) return param;

  const date = new Date(param);
  const offsetInMinutes = date.getTimezoneOffset();
  // Adjust for timezone offset (convert to milliseconds)
  date.setMinutes(date.getMinutes() - offsetInMinutes);

  return date
    .toLocaleString("en-US", {
      hour12: false,
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
    .replace(/\//g, "-")
    .replace(",", "");
};
